import React, { forwardRef } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

function withParams(Component) {
  const WrappedComponent = forwardRef((props, ref) => {
    const params = useParams();
    const [searchParams, setSearchParams] = useSearchParams();

    return (
      <Component
        {...props}
        params={params}
        searchParams={searchParams}
        setSearchParams={setSearchParams}
        ref={ref}
      />
    );
  });

  WrappedComponent.displayName = `withParams(${Component.displayName || Component.name})`;
  return WrappedComponent;
}

export default withParams;
